import Api from '@/api'

const api = new Api()
const projectApi = api.sales().project()
const costingsApi = api
  .sales()
  .bid()
  .costings()

export default {
  async fetchCostings({ commit }, payload) {
    try {
      const resp = await costingsApi.history(payload.bidNumber).detail(payload.record)
      const response = resp.data.data
      commit('Dashboard/setFeedback', response, { root: true })
      return response
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        { message: 'Invalid BidNumber Or History of Costings does not exist yet', errors: 500 },
        { root: true },
      )
    }
  },
  async fetchAllCostings({ commit }, payload) {
    try {
      const resp = await costingsApi.history(payload).all()
      const response = resp.data.data
      commit('Dashboard/setFeedback', response, { root: true })
      return response
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        { message: 'Invalid BidNumber Or History of Costings does not exist yet', errors: 500 },
        { root: true },
      )
    }
  },
  async addPurchaseNumber({ commit }, payload) {
    try {
      const resp = await projectApi.overview(payload.bidNumber).purchaseNumber(payload)
      const response = resp.data.data
      commit('Bid/setPurchaseNumber', response.purchaseNumber, { root: true })
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit('Dashboard/setFeedback', { message: err, errors: 500 }, { root: true })
    }
  },
  async addInvoice({ commit }, payload) {
    try {
      const resp = await projectApi
        .overview(payload.bidNumber)
        .invoice()
        .add(payload.invoice)
      const response = resp.data.data
      commit('Bid/setInvoice', response?.invoice, { root: true })
      commit('Bid/setDetails', response?.details, { root: true })
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit('Dashboard/setFeedback', { message: err, errors: 500 }, { root: true })
    }
  },
  async deleteInvoice({ commit }, payload) {
    try {
      const resp = await projectApi
        .overview(payload.bidNumber)
        .invoice()
        .delete(payload.invoice)
      const response = resp.data.data
      commit('Bid/removeInvoice', response?.invoice, { root: true })
      commit('Bid/setDetails', response?.details, { root: true })
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit('Dashboard/setFeedback', { message: err, errors: 500 }, { root: true })
    }
  },
  async issueInvoice({ commit }, payload) {
    try {
      const resp = await projectApi
        .overview(payload.bidNumber)
        .invoice()
        .issue(payload.invoice)
      const response = resp.data.data
      commit('Bid/setInvoice', response?.invoice, { root: true })
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit('Dashboard/setFeedback', { message: err, errors: 500 }, { root: true })
    }
  },
  async addAccrual({ commit }, payload) {
    try {
      const resp = await projectApi
        .overview(payload.bidNumber)
        .accrual()
        .add(payload.accrual)
      const response = resp.data.data
      commit('Bid/setAccrual', response?.accrual, { root: true })
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit('Dashboard/setFeedback', { message: err, errors: 500 }, { root: true })
    }
  },
  async deleteAccrual({ commit }, payload) {
    try {
      const resp = await projectApi
        .overview(payload.bidNumber)
        .accrual()
        .delete(payload.accrual)
      const response = resp.data.data
      commit('Bid/removeAccrual', response?.accrual, { root: true })
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit('Dashboard/setFeedback', { message: err, errors: 500 }, { root: true })
    }
  },
  async addDeferral({ commit }, payload) {
    try {
      const resp = await projectApi
        .overview(payload.bidNumber)
        .deferral()
        .add(payload.deferral)
      const response = resp.data.data
      commit('Bid/setDeferral', response?.deferral, { root: true })
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit('Dashboard/setFeedback', { message: err, errors: 500 }, { root: true })
    }
  },
  async deleteDeferral({ commit }, payload) {
    try {
      const resp = await projectApi
        .overview(payload.bidNumber)
        .deferral()
        .delete(payload.deferral)
      const response = resp.data.data
      commit('Bid/removeDeferral', response?.deferral, { root: true })
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit('Dashboard/setFeedback', { message: err, errors: 500 }, { root: true })
    }
  },
  async addFeeAdjustment({ commit }, payload) {
    try {
      const resp = await projectApi
        .overview(payload.bidNumber)
        .feeAdjustment()
        .add(payload.adjustment)
      const response = resp.data.data
      commit('Bid/setFeeAdjustment', response, { root: true })
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit('Dashboard/setFeedback', { message: err, errors: 500 }, { root: true })
    }
  },
  async deleteFeeAdjustment({ commit }, payload) {
    try {
      const resp = await projectApi
        .overview(payload.bidNumber)
        .feeAdjustment()
        .delete(payload.adjustment)
      const response = resp.data.data
      commit('Bid/removeFeeAdjustment', response, { root: true })
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit('Dashboard/setFeedback', { message: err, errors: 500 }, { root: true })
    }
  },
  async cancellation({ commit }, payload) {
    try {
      const resp = await projectApi.cancellation(payload)
      const response = resp.data.data
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit('Dashboard/setFeedback', { message: err, errors: 500 }, { root: true })
    }
  },
  async association({ commit }, payload) {
    try {
      const resp = await projectApi.association(payload)
      const response = resp.data.data
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit('Dashboard/setFeedback', { message: err, errors: 500 }, { root: true })
    }
  },
}
